import { render, staticRenderFns } from "./TbodyPockets.vue?vue&type=template&id=73616462"
import script from "./TbodyPockets.vue?vue&type=script&lang=js"
export * from "./TbodyPockets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports